import { FaSeedling } from "react-icons/fa";
import IconNorskTipping from "../../../themes/icons/NorskTipping";
import ButtonTomatoClose from "../../ui/buttons/ButtonTomatoClose";
import ButtonTutorial from "../../ui/buttons/ButtonTutorial";
import styles from "./Learn.module.scss";
import { useSearchParams } from "react-router-dom";

function Learn({ onClick }) {
  const [searchParams] = useSearchParams();

  const version = searchParams.get("version");

  const handleClose = () => {
    onClick("null");
  };

  const handleChange = (val) => {
    onClick(val);
  };

  return (
    <div className={`${styles["background"]} ${styles["background--1"]}`}>
      <div className={`${styles["foreground"]} ${styles["foreground--1"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["intro"]}>
          <p>
            <b className={styles["color--green-dark"]}>Welcome!</b> This section contains
            interactive guides to help you familiarize with Tomato. Have in mind, that all tutorials
            are also available in text format or video guides. Don't forget to check the{" "}
            <a
              href="https://testify.no/en/tomato-en/tutorials-en/"
              target="_blank"
              className={styles["address"]}
              rel="noreferrer">
              web site.
            </a>
          </p>
        </div>
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            {/* <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="Introduction"
              subtitle="This tutorial does not follow any strict rule. Feel free to explore and create your own model."
              onClick={() => handleChange("def1")}
            /> */}
            {version === "norsktipping" ? (
              <ButtonTutorial
                theme="green"
                icon={<IconNorskTipping />}
                title="Norsk Tipping"
                subtitle="Dedicated workshop tutorial"
                // address="https://testify.no/en/tomato-en/tutorials-en/how-to-create-your-first-function/"
                onClick={() => handleChange("dNT1")}
              />
            ) : null}
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="How to create your first function"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/how-to-create-your-first-function/"
              onClick={() => handleChange("firstFunction1")}
            />
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="Global parameters"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/global-parameters/"
              onClick={() => handleChange("globalParameters1")}
            />
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="Logic"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/logic/"
              onClick={() => handleChange("logic1")}
            />
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="Output parameters"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/output-parameters/"
              onClick={() => handleChange("output1")}
            />
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="Abstract choices and values"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/choice-hierarchy-values-and-labels/"
              onClick={() => handleChange("hav1")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Learn;
